import { Component, OnInit } from '@angular/core';
import { ContainerTypeService } from '../../core/services/container-type.service';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { RouterModule } from '@angular/router';
import { NewButtonComponent } from '../../shared/components/new-button/new-button.component';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { ContainerType } from '../../core/models/container-type.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { ContainerTypeDetailComponent } from '../container-type-detail/container-type-detail.component';

@Component({
  selector: 'app-container-type-list',
  templateUrl: './container-type-list.component.html',
  styleUrls: ['./container-type-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    RouterModule,
    NewButtonComponent,
    ConfirmPopupComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    ContainerTypeDetailComponent,
  ],
})
export class ContainerTypeListComponent implements OnInit {
  containerTypes: ContainerType[] = [];
  containerTypeToDelete: ContainerType | null = null;
  selectedContainerType: ContainerType | null = null; // Para el tipo de envase seleccionado
  tableColumns = [
    { header: 'ID', field: 'id' },
    { header: 'Nombre', field: 'name' },
    { header: 'Desactivado', field: 'disabled' },
  ];

  constructor(private containerTypeService: ContainerTypeService) {}

  ngOnInit(): void {
    this.getContainerTypes();
  }

  getContainerTypes(): void {
    this.containerTypeService
      .getContainerTypes()
      .subscribe(containerTypes => (this.containerTypes = containerTypes));
  }

  confirmDelete(containerType: ContainerType): void {
    this.containerTypeToDelete = containerType;
  }

  onDeleteConfirm(): void {
    if (this.containerTypeToDelete && this.containerTypeToDelete.id !== undefined) {
      this.containerTypeService.deleteContainerType(this.containerTypeToDelete.id).subscribe(() => {
        this.getContainerTypes();
        this.containerTypeToDelete = null;
      });
    }
  }

  onDeleteCancel(): void {
    this.containerTypeToDelete = null;
  }

  toggleContainerTypeStatus(containerType: ContainerType): void {
    containerType.disabled = !containerType.disabled;
    this.containerTypeService.disabledContainerType(containerType).subscribe(() => {
      this.getContainerTypes();
    });
  }

  selectContainerType(containerType: ContainerType): void {
    this.selectedContainerType = containerType; // Asigna el tipo de envase seleccionado
  }

  closeContainerTypeDetail(): void {
    this.selectedContainerType = null; // Cierra el detalle del tipo de envase
  }
}
